module.exports = __webpack_public_path__ + "img/05张海良.bb53faef.jpg";